namespace Areas.Analysis.DataReview {
    "use strict";

    var tabItems = Areas.createTabsWithSameController("Analysis", ["OvernightSnapshotActive", "OvernightSnapshotCompleted", "OvernightSnapshotOther", "WebProfile", "CIBProfile"], "DataReview");

    export function tabInitialized(params: any) {
        return Areas.tabInitialized(tabItems)(params);
    }

    export function webLinkProjectTemplate(cellElement, cellInfo) {
        const linktext = String(cellInfo.data.webLinkProject);
        if (linktext != 'null') {
            let linkInfo = '<a href= "' + linktext + '" target="_blank">' + String(cellInfo.data.accountId) + '</a>';
            cellElement.html(linkInfo);
        }
    }

    export function webLinkSharePointTemplate(cellElement, cellInfo) {
        const linktext = String(cellInfo.data.webLinkSharePoint);
        if (linktext != 'null') {
            let linkInfo = '<a href= "' + linktext + '" target="_blank">link</a>';
            cellElement.html(linkInfo);
        }
    }

    export function webLinkContractTemplate(cellElement, cellInfo) {
        const linktext = String(cellInfo.data.webLinkContract);
        if (linktext != 'null') {
            let linkInfo = '<a href= "' + linktext + '" target="_blank">' + String(cellInfo.data.contractId) + '</a>';
            cellElement.html(linkInfo);
        }
    }

    export function webLinkPlanRoomTemplate(cellElement, cellInfo) {
        const linktext = String(cellInfo.data.webLinkPlanRoom);
        if (linktext != 'null') {
            let linkInfo = '<a href= "' + linktext + '" target="_blank">link</a>';
            cellElement.html(linkInfo);
        }
    }

    export function onCellPrepared(e: any) {
        if (e.rowType === "header") {
            setColumnHeaderColor(e);
            return;
        }
        //setColumnHeaderColor(e);
    }

    function setColumnHeaderColor(e) {

        if (e.column.caption === "CIB") {
            e.cellElement.css("background-color", "Seashell");
        }
        if (e.column.dataField === "originalCIB") {
            e.cellElement.css("background-color", "Seashell");
        }
        if (e.column.dataField === "increaseCIB") {
            e.cellElement.css("background-color", "Seashell");
        }
        if (e.column.dataField === "currentCIB") {
            e.cellElement.css("background-color", "Seashell");
        }
        if (e.column.dataField === "projectApprovalDate") {
            e.cellElement.css("background-color", "Seashell");
        }


        if (e.column.caption === "Contract") {
            e.cellElement.css("background-color", "Honeydew");
        }
        if (e.column.dataField === "ntpDate") {
            e.cellElement.css("background-color", "Honeydew");
        }
        if (e.column.dataField === "originalContractSCDate") {
            e.cellElement.css("background-color", "Honeydew");
        }
        if (e.column.dataField === "revisedContractSCDate") {
            e.cellElement.css("background-color", "Honeydew");
        }
        if (e.column.dataField === "scDate") {
            e.cellElement.css("background-color", "Honeydew");
        }


        if (e.column.caption === "Finance") {
            e.cellElement.css("background-color", "Ivory");
        }
        if (e.column.dataField === "pifpafAmount") {
            e.cellElement.css("background-color", "Ivory");
        }
        if (e.column.dataField === "appropriation") {
            e.cellElement.css("background-color", "Ivory");
        }
        if (e.column.dataField === "irsDeclaration") {
            e.cellElement.css("background-color", "Ivory");
        }



        if (e.column.caption === "PM Schedule") {
            e.cellElement.css("background-color", "LavenderBlush");
        }
        if (e.column.dataField === "cApproved") {
            e.cellElement.css("background-color", "LavenderBlush");
        }
        if (e.column.dataField === "cEndApproved") {
            e.cellElement.css("background-color", "LavenderBlush");
        }

    }

}


                                               